import type { AppProps, ProjectTypeId, AnalyticsEvent } from '../model/types.tsx';

// INITIALIZE APP PROPS
export const INITIALIZE_APP_PROPS = 'state.INITIALIZE_APP_PROPS' as const;
export type InitializeAppPropsPayload = AppProps;
export type InitializeAppPropsAction = {
	type: typeof INITIALIZE_APP_PROPS;
	payload: InitializeAppPropsPayload;
};
export const initializeAppProps = (
	payload: InitializeAppPropsPayload,
): InitializeAppPropsAction => ({
	type: INITIALIZE_APP_PROPS,
	payload,
});

export const PROJECT_TYPE_CHANGED = 'state.PROJECT_TYPE_CHANGED' as const;
export type ProjectTypeChangedPayload = ProjectTypeId[];
export type ProjectTypeChangedAction = {
	type: typeof PROJECT_TYPE_CHANGED;
	payload: ProjectTypeChangedPayload;
	meta: {
		analyticsEvent: AnalyticsEvent;
	};
};
export const projectTypeChanged = (
	payload: ProjectTypeChangedPayload,
	analyticsEvent: AnalyticsEvent,
): ProjectTypeChangedAction => ({
	type: PROJECT_TYPE_CHANGED,
	payload,
	meta: {
		analyticsEvent,
	},
});

export type Action = InitializeAppPropsAction | ProjectTypeChangedAction;
